import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { LevelPieChart } from "./charts-metrics/LevelPieChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import html2canvas from "html2canvas";
import { ProgramTable } from "./charts-metrics/ProgramTable";
import { fetchPrograms, fetchReportPrograms } from "../../services/httpClient";

const Programs = ({ buildPDF, canvas, setCanvas, iPad }: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [reportRunning, setReportRunning] = useState<boolean>(false);
  const [programData, setProgramData] = useState<any[]>([]);
  const [programs, setPrograms] = useState<any[]>([]);

  useEffect(() => {
    getProgramData();
  }, []);

  const getProgramData = () => {
    fetchReportPrograms()
      .then((res: any) => {
        const progData = res[0]?.data ?? [];
        setProgramData(progData);

        fetchPrograms()
          .then((res: any) => {
            const programs = res[0]?.data ?? [];

            const flattenedProgs = programs.flatMap((prog: any) => {
              const levels = prog.programLevels ?? [];

              // Add level name to each programData entry
              progData.forEach((d: any) => {
                if (d.program_id === prog.id) {
                  const level = levels.find((l: any) => l.id === d.level_id);
                  d.level = level?.name;
                }
              });

              const levelEntries = levels.map((level: any) => {
                const levelCount = progData.filter((d: any) => d.level_id === level.id).length;

                return {
                  ...prog,
                  id: `${prog.id}-${level.id}`,
                  level_id: level.id,
                  program_id: prog.id,
                  name: `${prog.name} - ${level.name} (${levelCount})`,
                  key: `${prog.id}-${level.id}`,
                };
              });

              // Always include the base program entry
              const baseCount = progData.filter((d: any) => d.program === prog.name).length;
              const baseProgramEntry = {
                ...prog,
                id: prog.id,
                program_id: prog.id,
                name: `${prog.name} (${baseCount})`,
                key: prog.id,
              };

              return [baseProgramEntry, ...levelEntries];
            });

            setPrograms(flattenedProgs);
          })
          .catch((err: any) => console.log(err))
          .finally(() => {
            setIsLoading(false);
          });
      })
      .catch((err: any) => console.log(err));
  };

  useEffect(() => {
    if (reportRunning) {
      buildPDF();
      setReportRunning(false);
    }
  }, [canvas]);

  const downloadReport = async () => {
    setReportRunning(true);
    const reportSection = document.getElementById("programs-section");
    const reportTitle = document.getElementById("programs-title");
    const programsPie = document.getElementById("programs-pie");
    const programsFilters = document.getElementById("programs-filters");
    const pagination = document.getElementById("programs-pagination");

    if (reportSection) {
      if (reportTitle) {
        reportTitle.style.visibility = "hidden";
        reportTitle.style.display = "none";
      }

      if (programsPie) {
        programsPie.style.visibility = "hidden";
        programsPie.style.display = "none";
      }

      if (programsFilters) {
        programsFilters.style.visibility = "hidden";
        programsFilters.style.display = "none";
      }

      if (pagination) {
        pagination.style.visibility = "hidden";
        pagination.style.display = "none";
      }

      const images = reportSection.getElementsByTagName("img");
      for (let i = 0; i < images.length; i++) {
        images[i].crossOrigin = "anonymous";
      }

      const canvas = await html2canvas(reportSection, { useCORS: true });
      setCanvas(canvas);

      if (reportTitle) {
        reportTitle.style.visibility = "visible";
        reportTitle.style.display = "flex";
      }

      if (programsPie) {
        programsPie.style.visibility = "visible";
        programsPie.style.display = "flex";
      }

      if (programsFilters) {
        programsFilters.style.visibility = "visible";
        programsFilters.style.display = "flex";
      }

      if (pagination) {
        pagination.style.visibility = "visible";
        pagination.style.display = "flex";
      }
    } else {
      console.error("Report section not found");
      setReportRunning(false);
    }
  };

  return (
    <div id="programs-section">
      {isLoading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" style={{ color: "#F6893D" }} />
        </div>
      ) : (
        <>
          <Row id="programs-title" className="mb-3">
            <Col className="col-8">
              <h4 className="mb-0 app-header-text">Programming</h4>
            </Col>
            <Col className="col-4 text-end">
              {!iPad && (
                <Button className="app-primary-color button" onClick={() => downloadReport()}>
                  <FontAwesomeIcon icon={faDownload} />
                  {" Report"}
                </Button>
              )}
            </Col>
          </Row>
          {programData?.length > 0 ? (
            <>
              <Row id="programs-pie" className="justify-content-start mb-3">
                <Col xs={12}>
                  <LevelPieChart data={programData} />
                </Col>
              </Row>
              <ProgramTable data={programData} programList={programs} />
            </>
          ) : (
            <p className="mt-2">No Program Records</p>
          )}
        </>
      )}
    </div>
  );
};

export default Programs;
